<template>
  <div class="compound banner public-content">
    <div class="breadcrumb">首页banner <el-button style="margin-left: 10px;" round @click="detail()" v-preventReClick>新建</el-button>
    </div>
    <div class="right-main">
      <div class="data-list">
        <div class="main-content">
          <div class="banner-table">
            <el-table border class="table-cell" :data="tableList">
              <el-table-column label="" width="100">
                <template slot-scope="">
                  <!-- :style="clickId === scope.row.id ? 'color:#409EFF' : 'color:#bfbfbf'" -->
                  <i class="el-icon-s-unfold"></i>
                </template>
              </el-table-column>
              <el-table-column label="banner图片">
                <template slot-scope="scope">
                  <el-image :src="scope.row.bannerUrl" :preview-src-list="[scope.row.bannerUrl]">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column prop="isShow" label="详情图">
                <template slot-scope="scope">
                  <div v-if="scope.row.detailsUrl.length > 0">
                    <el-image v-for="(item, index) in scope.row.detailsUrl" :key="'aa' + index" style="width: 100%;" :src="item" :preview-src-list="scope.row.detailsUrl">
                    </el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="关联名称id">
                <template slot-scope="scope"> {{ scope.row.associationName }}：{{ scope.row.associationId }} </template>
              </el-table-column>
              <el-table-column label="操作">
                <template v-slot="scope">
                  <span class="color-blue" @click="detail(scope.row.id)">编辑<br></span>
                  <span class="color-blue" @click="deleteBanner(scope.row.id)">删除</span>
                </template>
              </el-table-column>
            </el-table>
            <div style="color:red">注：拖<i class="el-icon-s-unfold" style="color:#bfbfbf"></i>可调整滑块顺序</div>
            <div class="form-btn" style="margin: 20px 0" v-if="isDrop">
              <el-button round @click="cancel()" v-preventReClick>取消</el-button>
              <el-button round type="primary" @click="submit()" v-preventReClick>保存</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBannerPage, delBanner } from '@/api/banner'
import { appBannerList, updateBannerById, updateBannerInfo, deleteBannerById } from '@/api/pms'
import Sortable from 'sortablejs'
export default {
  name: 'banner',
  data () {
    return {
      haveName: false,
      modelName: '',
      dialogVisible: false,
      isDrop: false,
      clickId: 0,
      tableList: [],
      formInline: {
        type: null
      },
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      types: [{
        label: '新品发布',
        value: '0'
      }, {
        label: '项目展示',
        value: '1'
      }
        //  {
        //   label: 'C端活动推广',
        //   value: '2'
        // }
      ],
      form: {},
      where: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      tableData: []
    }
  },
  computed: {
    // prodName () {
    //   return (val) => {
    //     let str = ''
    //     let obj = this.tableData.find(v => v.id === val.relationId)
    //     str = obj?.spuName
    //     return str
    //   }
    // }
  },
  mounted () {
    // 阻止默认行为
    document.body.ondrop = function (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    // 调用 table拖拽排序
    this.rowDrop()
  },
  async created () {
    await this.getAppBannerList()
    if (this.$checkAwsSdk('normal')) {
      this.$store.dispatch('awsSdk/getAwsSdk', 'normal')
    }
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    // 行拖拽
    rowDrop () {
      let tbody = document.querySelector('.el-table__body-wrapper tbody')
      let _this = this
      Sortable.create(tbody, {
        // or { name: "...", pull: [true, false, 'clone', array], put: [true, false, array] }
        group: {
          name: 'words',
          pull: true,
          put: true
        },
        animation: 150, // ms, number 单位：ms，定义排序动画的时间
        onAdd: function (evt) { // 拖拽时候添加有新的节点的时候发生该事件
          console.log('onAdd.foo:', [evt.item, evt.from])
        },
        onUpdate: function (evt) { // 拖拽更新节点位置发生该事件
          console.log('onUpdate.foo:', [evt.item, evt.from])
        },
        onRemove: function (evt) { // 删除拖拽节点的时候促发该事件
          console.log('onRemove.foo:', [evt.item, evt.from])
        },
        onStart: function (evt) { // 开始拖拽出发该函数
          // this.clickId = evt
          console.log('onStart.foo', evt.oldIndex)
          let aaaa = _this.tableList[evt.oldIndex]
          console.log('aaaa', aaaa)
          // _this.clickId = aaaa.id
        },
        onSort: function (evt) { // 发生排序发生该事件
          console.log('onUpdate.foo:', [evt.item, evt.from])
        },
        // 一般的业务就用onEnd结束拖拽就够了
        onEnd ({ newIndex, oldIndex }) { // 结束拖拽
          if (newIndex == oldIndex) return
          let currRow = _this.tableList.splice(oldIndex, 1)[0]
          // console.log('currRow', newIndex, currRow)
          _this.tableList.splice(newIndex, 0, currRow)
          let newArray = _this.tableList.splice(0)
          _this.$nextTick(() => {
            _this.isDrop = true
            _this.tableList = newArray
            console.log('onEnd', _this.tableList)
          })
        }
      })
    },
    async getAppBannerList () {
      await appBannerList({}).then(res => {
        if (res.data.success) {
          let dataList = res.data.data.map(res => {
            return {
              ...res,
              detailsUrl: res.detailsUrl ? res.detailsUrl.split(',') : []
            }
          })
          this.tableList = dataList
          this.tableData = Object.assign([], dataList)
          // this.queryInfo.total = res.data.data.total
        }
      })
    },
    detail (bannerId) {
      this.$router.push({
        path: '/app/bannerDetail',
        query: {
          id: bannerId,
          type: 'edit'
        }
      })
    },
    deleteBanner (bannerId) {
      this.$confirm('是否确定删除该Banner?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteBannerById(bannerId).then(res => {
          if (res.data.success) {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            })
            this.getAppBannerList()
          }
        })
      })
    },
    cancel () {
      this.clickId = 0
      this.isDrop = false
      this.tableList = Object.assign([], this.tableData)
    },
    submit () {
      let param = this.tableList.map((a, i) => {
        delete a.updateTime
        delete a.createTime
        return {
          ...a,
          sort: i + 1,
          detailsUrl: a.detailsUrl.toString()
        }
      })
      updateBannerInfo(param).then(res => {
        console.log('res', res)
        if (res.data.success) {
          this.$message.success('保存成功')
          this.clickId = 0
          this.isDrop = false
          this.getAppBannerList()
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.el-icon-s-unfold {
  color: #bfbfbf;
}

.el-icon-s-unfold:hover {
  color: #409EFF;
}

.compound {
  .add-category {
    justify-content: flex-start;
  }

  .keywords {
    display: flex;
    justify-content: space-around;
    // width: 750px;
    align-items: center;

    .el-input {
      width: 180px;
    }
  }
}
</style>
